import React from 'react';
import { TrackedLink as Link } from 'components/common/TrackedLink';
import styled from 'styled-components';
import { CEB_COLOR } from 'app-constants/CEB_COLOR';
import { Snippet } from '__generated__/graphql';

export interface LinkedResultSnippetsProps {
  snippets: Snippet[];
  url: string | null;
  separator?: boolean;
}

export const LinkedResultSnippets = ({
  snippets,
  url,
}: LinkedResultSnippetsProps) => (
  <StyledLinkedResultSnippet>
    {snippets.map((snippet, i) =>
      url ? (
        <Link
          key={i}
          to={`${url}${snippet.position ? `#${snippet.position}` : ''}`}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: snippet.text || '',
            }}
          />
        </Link>
      ) : (
        <span
          key={i}
          dangerouslySetInnerHTML={{
            __html: snippet.text || '',
          }}
        />
      ),
    )}
  </StyledLinkedResultSnippet>
);

export const StyledLinkedResultSnippet = styled.span`
  display: inline;
  font-size: 16px;
  line-height: 1.5;
  a,
  a:visited,
  span {
    display: block;
    color: inherit;
  }
  a {
    &:hover {
      text-decoration: underline;
    }
    margin-bottom: 2px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  b {
    font-weight: inherit;
    background-color: ${CEB_COLOR('CITRINE_WHITE')};
  }
`;
